import { render, staticRenderFns } from "./ScrollingFooter.vue?vue&type=template&id=19873fa8&scoped=true&"
import script from "./ScrollingFooter.vue?vue&type=script&lang=ts&"
export * from "./ScrollingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollingFooter.vue?vue&type=style&index=0&id=19873fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19873fa8",
  null
  
)

export default component.exports